export default "__VITE_ASSET__jVDAOgCN__"